<template>
    <x-modal
        :wWidth="1100"
        v-if="visible"
        @cancel="closeModal"
        @close="closeModal"
        @ok="saveLeadScore"
        :draggable="true"
        :resizable="true"
        :loading="loading"
        :okDisabled="loading"
        :okText="'Score'"
    >
        <div slot="title" :class="`d-flex justify-content-between align-items-center`">
            Lead Scoring
        </div>

        <div class="mb-2 d-flex justify-content-end">
            <el-button @click="addAmount"><i class="fas fa-plus"></i> Add</el-button>
        </div>

        <div class="mb-2">
            <el-table
                :data="scores"
                fit
                style="width: 100%">
                <el-table-column
                    prop="label"
                    label="Lead Score Label"
                    width="180">
                    <template slot-scope="scope">
                        <el-select class="w-100" v-model="scope.row.label" placeholder="Amount" clearable>
                            <el-option
                                v-for="scoreOption in select.scoreOptions"
                                :key="scoreOption.value"
                                :label="scoreOption.label"
                                :value="scoreOption.label">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="operand"
                    label="Lead Score Operator"
                    width="180">
                    <template slot-scope="scope">
                        <el-select class="w-100"
                                   v-model="scope.row.operand"
                                   placeholder="Operand"
                                   label="Lead Operator"
                                   clearable
                                   :disabled="
                                    scope.row.label === 'Assets' ||
                                    scope.row.label === 'Lead Source' ||
                                    scope.row.label === 'Lead Source Detail' ||
                                    scope.row.label === 'Application Type' ||
                                    scope.row.label === 'Loan Type' ||
                                    scope.row.label === 'Residency Status' ||
                                    scope.row.label === 'Residential Status' ||
                                    scope.row.label === 'Referral Partner'
                                  "
                        >
                            <el-option
                                v-for="scoreOption in select.operandOptions"
                                :key="scoreOption.value"
                                :label="scoreOption.label"
                                :value="scoreOption.label">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="value"
                    label="Lead Score Value"
                    width="210">
                    <template slot-scope="scope">
                        <el-input-number v-if="scope.row.label == 'Amount'" class="w-100"
                                         v-model="scope.row.value"></el-input-number>

                        <el-input-number v-else-if="scope.row.label == 'Credit rating'" class="w-100"
                                         v-model="scope.row.value"></el-input-number>

                        <el-select v-else-if="scope.row.label == 'Assets'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Assets" clearable multiple>
                            <el-option
                                v-for="assetType in assetTypes"
                                :key="assetType.value"
                                :label="assetType.label"
                                :value="assetType.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Previous Customers With Settled Deals'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Previous Customers With Settled Deals" clearable>
                            <el-option
                                v-for="yesNo in select.selectYesNo"
                                :key="yesNo.value"
                                :label="yesNo.label"
                                :value="yesNo.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Previous Customers Without Settled Deals'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Previous Customers Without Settled Deals" clearable>
                            <el-option
                                v-for="yesNo in select.selectYesNo"
                                :key="yesNo.value"
                                :label="yesNo.label"
                                :value="yesNo.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Lead Source'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Lead Source"
                                   clearable>
                            <el-option
                                v-for="leadSource in sourceOptions"
                                :key="leadSource.value"
                                :label="leadSource.label"
                                :value="leadSource.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Lead Source Detail'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Lead Source Detail" clearable
                                   multiple>
                            <el-option
                                v-for="leadSourceDetail in select.selectSourceDetails"
                                :key="leadSourceDetail.value"
                                :label="leadSourceDetail.label"
                                :value="leadSourceDetail.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Application Type'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Application Type" clearable>
                            <el-option
                                v-for="applicationTypeSelect in select.applicationTypesSelect"
                                :key="applicationTypeSelect.value"
                                :label="applicationTypeSelect.label"
                                :value="applicationTypeSelect.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Loan Type'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Loan Type" clearable multiple>
                            <el-option
                                v-for="selectLoanType in select.selectLoanTypes"
                                :key="selectLoanType.value"
                                :label="selectLoanType.label"
                                :value="selectLoanType.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Residency Status'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Residency Status" clearable>
                            <el-option
                                v-for="residentialStatus in select.residentialStatuses"
                                :key="residentialStatus.value"
                                :label="residentialStatus.label"
                                :value="residentialStatus.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Residential Status'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Residential Status" clearable>
                            <el-option
                                v-for="residentialStatus in residentialStatusOptions"
                                :key="residentialStatus.value"
                                :label="residentialStatus.label"
                                :value="residentialStatus.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.label == 'Referral Partner'"
                                   class="w-100"
                                   v-model="scope.row.value"
                                   placeholder="Referral Partner" clearable>
                            <el-option
                                v-for="yesNo in select.selectYesNo"
                                :key="yesNo.value"
                                :label="yesNo.label"
                                :value="yesNo.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="value2"
                    label="Lead Score Second Value"
                    width="210">
                    <template slot-scope="scope">
                        <el-input-number v-if="scope.row.operand == 'between' && scope.row.label == 'Amount'"
                                         class="w-100" v-model="scope.row.value2"></el-input-number>
                        <el-input-number
                            v-else-if="scope.row.operand == 'between' && scope.row.label == 'Credit rating'"
                            class="w-100" v-model="scope.row.value2"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="score"
                    label="Lead Score"
                    width="180">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.score"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Action">
                    <template slot-scope="scope" v-if="scope.$index !== 0">
                        <a @click="remove(scope.$index, scope.row)"><i class="fas fa-times-circle text-danger ml-3"></i></a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </x-modal>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: 'LeadScoringModal',
    props: [
        'visible',
        'sources',
        'applications',
        'leadScoring'
    ],
    data() {
        return {
            loading: false,
            scores: [
                {
                    label: 'Amount',
                    operand: '<',
                    value: null,
                    value2: null,
                    score: null
                }
            ],
            leadScore: {
                amount: [
                    {
                        label: '<=5000',
                        value: 'less than equal to 5000'
                    }
                ],
                asset: [],
                previousCustomerWithSettledDeal: '',
                previousCustomerWithOutSettledDeal: '',
                leadSource: [],
                leadSourceDetail: [],
                applicationType: '',
                loanType: [],
                creditRating: '',
                foundAsset: '',
                assetBacked: ''
            },
            select: {
                scoreOptions: [
                    {label: 'Amount', value: 1},
                    {label: 'Assets', value: 2},
                    {label: 'Previous Customers With Settled Deals', value: 3},
                    {label: 'Previous Customers Without Settled Deals', value: 4},
                    {label: 'Lead Source', value: 5},
                    {label: 'Lead Source Detail', value: 6},
                    {label: 'Application Type', value: 7},
                    {label: 'Loan Type', value: 8},
                    {label: 'Credit rating', value: 9},
                    {label: 'Residency Status', value: 10},
                    {label: 'Residential Status', value: 11},
                    {label: 'Referral Partner', value: 12},
                ],
                operandOptions: [
                    {label: '=', value: 1},
                    {label: '<', value: 2},
                    {label: '>', value: 3},
                    {label: 'not equals', value: 4},
                    {label: 'between', value: 5},
                ],
                amountSelect: [
                    {label: '<=5000', value: 'less than equal to 5000'},
                    {label: '5001 - 30000', value: 'between 5001 and 30000'},
                    {label: '30001 +', value: 'above 30000'}
                ],
                applicationTypesSelect: [
                    {label: "Consumer", value: 1},
                    {label: "Commercial", value: 2}
                ],
                selectSourceDetails: [],
                selectYesNo: [
                    {label: 'Yes', value: 1},
                    {label: 'No', value: 0}
                ],
                selectLoanTypes: [],
                residentialStatuses: [
                    {label: "Citizen", value: 1},
                    {label: "Permanent Resident", value: 2},
                    {label: "Temporary Resident", value: 3}
                ]
            }
        }
    },
    computed: {
        ...mapState(["summary", "options"]),
        ...mapGetters({
            assetTypes: 'options/assetTypes',
            loanTypes: 'options/loanTypes',
            leadSources: 'options/sources',
            sourceDetails: 'options/sourceDetails',
            residentialStatusOptions: "options/residentialStatuses",
            user: "user/user",
        }),
        sourceOptions() {
            const sources = this.sources.map((source) => {
                return {
                    value: _.get(source, 'id', _.get(source, 'value')),
                    label: _.get(source, 'name', _.get(source, 'label')),
                }
            })

            return sources
        }
    },
    mounted() {
    },
    methods: {
        closeModal() {
            this.$emit('update:visible', false)
            this.$bus.$emit('reload:leadmanagement')
        },
        saveLeadScore() {
            const total_lead_score = _.sumBy(this.scores, 'score')
            const userId = this.user.id;

            this.loading = true

            this.$tenant
                .post(`/api/lead-management/score`, {
                    scores: this.scores,
                    applications: this.applications,
                    user_id: userId
                })
                .then((res) => {
                    if (res) {
                        swal({
                            title: "Success!",
                            type: "success",
                            text: `Lead Scoring Successfully`
                        })
                        this.closeModal()
                        this.loading = false
                    }
                })
                .catch((error) => {
                    swal({
                        title: "Error!",
                        type: "error",
                        text: `${JSON.stringify(_.get(error, 'response', 'Error Scoring Leads'))}`
                    })

                    this.loading = false
                })
        },
        addAmount() {
            this.scores.push({
                label: 'Amount',
                operand: '',
                value: null,
                value2: null,
                score: null
            })
        },
        remove(i, v) {
            const index = this.scores.indexOf(v);
            if (index > -1) {
                this.scores.splice(index, i);
            }
        },
        onlyNumbers(array) {
            return array.every(element => {
                return typeof element === 'number';
            });
        },
        leadSourcesDetail(value) {
            let source = this.sources.find((source) => value === _.get(source, 'id', _.get(source, 'value')))

            if (!_.isUndefined(source) && !_.isEmpty(source.detail)) {

                console.warn('leadSourcesDetail', source, value)
                // create the source details list based on the source
                let sourceDetails = source.detail.map((detail) => {
                    return {
                        value: detail.id,
                        label: detail.detail,
                    }
                })

                this.select.selectSourceDetails = _.sortBy(sourceDetails, "label")
            } else {
                this.select.selectSourceDetails = []
            }
        },
        setSelectLoanTypes(val) {
            val.map((score, i) => {
                if (score.label === 'Lead Source' && score.value) {
                    this.leadSourcesDetail(score.value)
                }

                if (score.label === 'Application Type') {
                    switch (score.value) {
                        case 1:
                            this.select.selectLoanTypes = this.loanTypes.filter(loanType => ['Consumer Loan', 'Personal Loan'].includes(loanType.label))
                            return this.select.selectLoanTypes
                        case 2:
                            this.select.selectLoanTypes = this.loanTypes.filter(loanType => !['Consumer Loan', 'Personal Loan'].includes(loanType.label))
                            return this.select.selectLoanTypes
                        default:
                            this.select.selectLoanTypes = []
                            break
                    }
                }
            })
        }
    },
    watch: {
        "scores": {
            handler(val, oldVal) {
                if (val) {
                    val.map((score, i) => {
                        if (
                            score.label === 'Assets' ||
                            score.label === 'Lead Source' ||
                            score.label === 'Lead Source Detail' ||
                            score.label === 'Application Type' ||
                            score.label === 'Loan Type' ||
                            score.label === 'Residency Status' ||
                            score.label === 'Residential Status' ||
                            score.label === 'Referral Partner') {
                            _.set(score, 'operand', '=')
                        }
                    })

                    this.setSelectLoanTypes(val)
                }
            },
            immediate: true,
            deep: true,
        },
        "leadScoring": {
            handler(val, oldVal) {
                if (_.size(val)) {
                    this.scores = val
                }
            },
            immediate: true,
            deep: true,
        },
    }
}

</script>
